<template>
  <div v-if="state" class="d-flex justify-content-center loading-box">
    <div class="spinner-grow text-primary loading-item" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    state: {
      type: Boolean,
      required: true
    }
  },
}
</script>

<style scoped>
.loading-box {
  z-index: 1100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.loading-item {
  margin-top: 20%;
}
</style>
